<!-- Loading -->
<div
  class="gd-list-table-data-loading">
  <mat-progress-spinner
    mode="indeterminate"
    diameter="32"></mat-progress-spinner>
</div>
